module.exports = __webpack_public_path__ + "img/Armorer2.91d9b69c.png";